/**
 * Rows-per-page choices of every paged table (ArzaLink) and their default. Pure (no React), so domain models parsing
 * the `size` query string value use the same list as `TableFooter`.
 */
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const

export type PageSize = (typeof PAGE_SIZE_OPTIONS)[number]

export const DEFAULT_PAGE_SIZE: PageSize = 25

/** A page size from a URL value: one of the options, otherwise the default. */
export function pageSizeOf(value: unknown): PageSize {
  const n = Number(value)
  return PAGE_SIZE_OPTIONS.find((option) => option === n) ?? DEFAULT_PAGE_SIZE
}
